import styled from 'styled-components';

const SocialWrapper = styled.div`
  align-items: center;
  display: flex;
  margin: ${props => (props.margin ? props.margin : '5%')};
  ${({ isDesktop }) => (isDesktop ? 'flex-wrap: wrap;' : '')};
`;

const SocialButton = styled.div`
  align-items: center;
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  ${({ isDesktop }) => (isDesktop ? 'margin-right: 5px;' : 'margin: auto 1em;')};
  ${({ isDesktop }) => (isDesktop ? 'padding-bottom: 5px;' : '')};
`;

const Title = styled(SocialButton)`
  color: ${({ isDesktop }) => (isDesktop ? '#000' : '#333333')};
  font-weight: ${({ isDesktop }) => (isDesktop ? 'normal' : 'bold')};
  margin: initial;
  text-transform: uppercase;
  ${({ isDesktop }) => (isDesktop ? 'flex: 1 0 100%;' : '')};
  ${({ isDesktop }) => (isDesktop ? 'justify-content: start;' : '')};
`;

export { SocialButton, SocialWrapper, Title };
